import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { ReactComponent as MinusIcon } from "../../../../../assets/icons/minus-cirlce.svg";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { useCustomHook } from "../../../../GlobalFunctions/globalFunctions";

const CallDates = ({ formik, updateModalState, modalData }) => {
  const [selectedDate, setSelectedDate] = useState("");
  const [callDatesDatas, setCallDatesDatas] = useState([]);

  const { callDatesStatusList } = useCustomHook();

  useEffect(() => {
    if (modalData?.callDates) {
      setCallDatesDatas(modalData.callDates);
    }
  }, [modalData]);

  const addDate = () => {
    if (!selectedDate) return;
    const alreadyExists = callDatesDatas.some((d) => d.date === selectedDate);
    if (!alreadyExists) {
      const newData = [
        ...callDatesDatas,
        { date: selectedDate, status: "", isFollowUp: false },
      ];

      setCallDatesDatas(newData);
      updateModalState("callDates", newData);
    }
    setSelectedDate("");
  };

  const updateItem = (index, field, value) => {
    const updated = [...callDatesDatas];
    updated[index][field] = value;
    setCallDatesDatas(updated);
    updateModalState("callDates", updated);
  };

  const removeDate = (index) => {
    const updated = callDatesDatas.filter((_, i) => i !== index);
    setCallDatesDatas(updated);
    updateModalState("callDates", updated);
  };

  return (
    <>
      <div>
        <div className="dropdown-input courses">
          <div className="left">
            <div className="input-box">
              <TextField
                sx={{
                  "& input": { fontSize: "12px", marginRight: "32px" },
                  marginTop: "24px",
                }}
                InputLabelProps={{
                  style: { fontSize: "12px", color: "#3F3F3F" },
                  shrink: true,
                }}
                fullWidth
                label="Əlaqə tarixləri"
                autoComplete="off"
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </div>
          </div>

          <div className="right">
            <button onClick={() => addDate()} className="add-class">
              <AiOutlinePlusCircle />
            </button>
          </div>
        </div>
        <ul className="category-list courses-li" style={{ marginTop: "16px" }}>
          {callDatesDatas.map((item, index) => (
            <li
              key={index}
              style={{
                display: "flex",

                gap: "10px",
                marginBottom: "8px",
                background: "#f7f7f7",
                padding: "8px 10px",
                borderRadius: "8px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span style={{ fontSize: "13px" }}>{item.date}</span>
                {/* Remove button */}
                <div>
                  <div className="minus-icon-con">
                    <MinusIcon
                      className="minus-icon"
                      onClick={() => removeDate(index)}
                    />
                  </div>
                </div>

                {/* Status dropdown */}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={item.isFollowUp}
                      onChange={(e) =>
                        updateItem(index, "isFollowUp", e.target.checked)
                      }
                    />
                  }
                  label="Follow-up"
                  sx={{ fontSize: "12px" }}
                />
                <select
                  style={{
                    fontSize: "12px",
                    padding: "4px 6px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                  value={item.status}
                  onChange={(e) => updateItem(index, "status", e.target.value)}
                >
                  <option value="">Status seç</option>
                  {callDatesStatusList.map((s) => (
                    <option key={s.key} value={s.key}>
                      {s.label}
                    </option>
                  ))}
                </select>
              </div>
            </li>
          ))}
        </ul>

        {formik.errors.courses && formik.touched.courses && (
          <small className="validation-err-message">
            {formik.errors.courses}
          </small>
        )}
      </div>
    </>
  );
};

export default CallDates;
